exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xm-sidebar[data-v-2124681e]{position:fixed;top:66px;z-index:29;width:200px;height:calc(100vh - 66px);margin-left:-200px;border-right:1px solid #b6b6b6;background:#fff}.xm-sidebar a[data-v-2124681e]{display:block;padding:0 20px;font-size:14px;line-height:40px;color:#444}.xm-sidebar a[data-v-2124681e]:hover{background-color:#f0f0f0;text-decoration:none!important}.xm-sidebar a.router-link-active[data-v-2124681e]{color:#0884f3;background:#ecf4fd}", ""]);

// exports
